import { motion, AnimatePresence } from "framer-motion";

const Sheet = ({ isOpen, onClose, children, title = "Panel", size = "default" }) => {
  // Configurar tamaños según el prop size
  const getSheetClasses = () => {
    switch (size) {
      case "fullscreen":
        return "fixed top-0 right-0 w-1/2 h-full bg-white shadow-xl z-50 flex flex-col";
      case "large":
        return "fixed top-0 right-0 w-full max-w-4xl h-full bg-white shadow-xl z-50 flex flex-col";
      case "medium":
        return "fixed top-0 right-0 w-full max-w-2xl h-full bg-white shadow-xl z-50 flex flex-col";
      default:
        return "fixed top-0 right-0 w-full max-w-md h-full bg-white shadow-xl z-50 flex flex-col";
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            onClick={onClose} // Ahora se puede cerrar con click en backdrop
          />
          <motion.div
            className={getSheetClasses()}
            initial={{ x: "100%", opacity: 1 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 1 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            {size !== "fullscreen" && (
              <div className="p-4 border-b flex justify-between items-center">
                <h3 className="text-xl font-semibold">{title}</h3>
                <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-2xl font-bold">
                  &times;
                </button>
              </div>
            )}
            <div className={`${size === "fullscreen" ? "h-full" : "p-6"} overflow-y-auto flex-grow`}>
              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Sheet;
